import { setUpErrorHandling } from '@bingads-webui-campaign/summary-grid-helper';
import {
  TargetingSettingsContext,
} from '@bingads-webui-campaign/targeting-settings-scaffolds';
import { LocationsGridView } from './locations-grid-view';
import { getConfig } from './locations-grid-config';
import { getPlugins } from './locations-grid-plugins';

export function createLocationGrid({
  // New UI options only
  filterService,
  router,
  viewport,
  customHeaderOffset,
  p$daterange,
  addDateChangeListener,
  preferenceConfig,
  renderRecommendation,
  // common options
  getAdditionalPlugins,
  dataSource,
  perfMarker,
  scope,
  level,
  gridName,
  campaignId,
  adgroupId,
  getView,
  permissions = {},
}) {
  return new LocationsGridView({
    router,
    scope,
    campaignId,
    adgroupId,
    level,
    dataSource,
    filterService,
    preferenceConfig,
    renderRecommendation,
    getGridConfig: (repository, columnConfig) => getConfig({
      repository,
      gridName,
      filterService,
      preferenceConfig,
      columnConfig,
      viewport,
      customHeaderOffset,
      i18n: TargetingSettingsContext.i18n,
      permissions,
    }),
    getGridPlugins: (view, columnConfig) => getPlugins({
      view,
      columnConfig,
      scope,
      level,
      perfMarker,
      filterService,
      p$daterange,
      addDateChangeListener,
    }).concat(getAdditionalPlugins(view)),
    setupDataSourceErrorHandling: (view, repository) => setUpErrorHandling({
      gridView: view,
      scope: {
        campaignId,
      },
      dataSource: repository.getQuery(),
      i18n: TargetingSettingsContext.i18n,
    }),
    getView,
  });
}
